// extracted by mini-css-extract-plugin
export default {"root":"FreePartiesBanner_root__DVlat","text":"FreePartiesBanner_text__8F8V6","cta":"FreePartiesBanner_cta__YGqbO"};